
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DirectorySharedDataService } from 'src/app/directory/services/directory-shared-data.service';
import { ValidateEmail } from 'src/app/shared/shared.module';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-directory-entity-creation-dialog',
  templateUrl: './directory-entity-creation-dialog.component.html',
  styleUrls: ['./directory-entity-creation-dialog.component.scss'],
})
export class DirectoryEntityCreationDialogComponent implements OnInit {
  public dialogForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<DirectoryEntityCreationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private directoryStore: DirectorySharedDataService,
    private snackbar: MatSnackBar,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.dialogForm = this.fb.group({
      name: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.required, ValidateEmail]),
      society: new FormControl(),
      phone: new FormControl(),
      address: new FormControl(),
      city: new FormControl(),
      message: new FormControl('', Validators.required),
    });
  }

  public cancelDialog(): void {
    this.dialogRef.close();
  }

  returnForm() {
    let creationRequest = {
      requester: {
        name: this.dialogForm.get('name').value,
        email: this.dialogForm.get('email').value
      },
      request: {
        company: this.dialogForm.get('society').value,
        address: this.dialogForm.get('address').value,
        city: this.dialogForm.get('city').value,
        phone: this.dialogForm.get('phone').value,
        message: this.dialogForm.get('message').value
      },
      email: this.data.contact_email,
    };

    this.directoryStore.createEntity(creationRequest).subscribe(
      (val)=> {
        this.snackbar.open(this.translate.instant("directory.creation.sent"), "OK");
        this.dialogRef.close();
      },
      (error)=> {
        this.snackbar.open(this.translate.instant("directory.creation.sent_e"), "OK");
      }
    )
  }
}
